import React, { useEffect } from "react";
import CarFinance from "../components/car-finance/index.jsx";
import SeoMeta from "../components/meta/index.jsx";

export default function Finance() {
  useEffect(() => {
    document.title = "Car Finance Pakistan | Famewheels";
  }, []);
  return (
    <>
     <SeoMeta
        title="Car Finance Pakistan | Famewheels"
        desc="Discover affordable car finance options in Pakistan with Famewheels and Dubai Islamic Bank Car Finance. Drive your dream car with easy financing plans tailored to your needs. Apply now for flexible, Sharia-compliant car loans."
        url="car-finance"
      />
      <CarFinance />
    </>
  );
}
